import { HttpResult, none, Option, some } from 'widgets-for-react';
import { RedirectResult } from './redirectState';

export const fetchRedirect : (_: string) => Promise<HttpResult<Option<RedirectResult>>> = async (path: string) => {
  const fetch_res = await fetch(`/api/v1/pages/redirect?path=${encodeURIComponent(path)}`, {
    method: 'get'
  });

  if(!fetch_res.ok) {
    return {kind: "failed", status: fetch_res.status}
  }

  return {kind: "result", status: 200, value: fetch_res.status === 204 ? none() : some(await fetch_res.json())}
}